import React from 'react';
import { connect } from 'react-redux'
import { NAME as WORD_PAIRS_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as wordPairsContainerActions } from '../actions'
import { strings } from "../../../constants/strings";
import Row from "../components/Row"
import timesUpImg from "../../../assets/timesup.svg";
import { CSSTransition } from "react-transition-group";

function mapStateToProps(state) {
  return {
    ...state[WORD_PAIRS_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wordPairsContainerActions
}, dispatch)

class WordPairsGrid extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      transitionIsFinished: false,
      round: 0,
      gameMatrix: props.gameMatrix  //Copy lettersMatrix to local state for animation
    }
  }

  componentDidMount() {
  }

  render() {
    return (
      <>
        <CSSTransition
          in={this.props.exersizeState === 'gameOver' && this.state.transitionIsFinished}
          timeout={400}
          classNames='opacity-transition'
          mountOnEnter
          unmountOnExit
        >
          <div steap={this.props.steap} className="thimes-up-container">
            <img
              src={timesUpImg}
              width="100"
              className="times-up-img"
              alt="Time's Up Clock"
            />
            <div className="times-up">{strings.ExerciseTimeUp}</div>
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'gameStarted'}
          timeout={200}
          classNames='opacity-transition'
          mountOnEnter
          unmountOnExit
          onExited = {()=>{
            this.setState({transitionIsFinished: true})
          }}
        >
          <div className="field">
          <CSSTransition
          in={this.state.round === this.props.currentRound || this.props.currentRound === 0}
          timeout={100}
          classNames='opacity-transition'
          mountOnEnter
          unmountOnExit  
          onExited = {()=>{
            this.setState({
              round: this.props.currentRound,
              gameMatrix: this.props.gameMatrix
            })
          }}        
        >
            <div className="container-fluid h-100">
              <div className="h-100 d-flex flex-column h-600">
                {this.state.gameMatrix.map((row, index) => (
                  <Row
                    onCellClick={this.props.onCellClick}
                    key={'row' + index}
                    row={row}
                    rowIndex={index}
                  />
                ))}
              </div>
            </div>
            </CSSTransition>
          </div>
        </CSSTransition>
      </>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WordPairsGrid)
